
import React from "react";
import { getBrand, getStudentDetails } from "../lib/functions";
import AssignmentListItem from "./AssignmentListItem.js";
import Footer from "./Footer.js";
import Settings from "./Settings.js";
import Sidebar from "./Sidebar";
import MobileHeader from "./MobileHeader";

export default class Main extends React.Component {
  /**
 * Initializes the Main component state.
 * @param {Object} props - React props.
 */
  constructor(props) {
    super(props);
    this.state = {
      brand: null,
      studentDetails: null,
      assignmentCounts: null,
      menuItems: null,
      listSelected: "active",
      urgent: false,
      hasAssignments: false,
      showSidebar: true,
      viewSelection: "Assignments due",
      viewSelectionFilter: "0",
      showSettings: false,
      isMobile: false
    };
  }

  /**
   * React lifecycle method.
   * Sets the brand, initializes student data, and sets sidebar visibility based on screen width.
   */
  componentDidMount = () => {
    this.setState({
      brand: getBrand()
    });
    this.init("0");

    if (window.screen.width > 600) {
      this.setState({ showSidebar: true });
    } else {
      this.setState({ showSidebar: false });
    }

    if (window.screen.width > 992) {
      this.setState({ isMobile: false });
    } else {
      this.setState({ isMobile: true });
    }

    window.addEventListener("focus", this.focusSelection)
  };

  componentWillUnmount() {
    window.removeEventListener("focus", this.focusSelection)
  }


focusSelection = () => {
  this.getSelection(null);
}


  /**
   * Initializes student details and menu items using the provided filter.
   * Updates assignment and menu state.
   * @param {string} filter - The filter to use for fetching student details.
   */
  init = (filter) => {

    getStudentDetails(filter, data => {
      const menuItemsSorted = [...data[1]].sort((a, b) => a.sortorder - b.sortorder);

      let filteredAssignments;
      if (filter == 0) {
        filteredAssignments = data[0].filter(assignment => assignment.status == "Active");
      } else if (filter == 1){
        filteredAssignments = data[0].filter(assignment => assignment.filtervalue != 3 );
      } else if (filter != 3) {
        filteredAssignments = data[0].filter(assignment => assignment.status != "Closed" );
      } else {
        filteredAssignments = data[0];
      }
        
        this.setState({ studentDetails: filteredAssignments,  menuItems: menuItemsSorted,  });
    

      if (data[0].length == 0) {
        this.setState({ hasAssignments: false });
      } else {
        this.setState({ hasAssignments: true });
      }
    });
  };


  /**
   * Toggles the sidebar open or closed.
   */
  sidebarToggle = () => {
    this.setState(prevState => ({ showSidebar: !prevState.showSidebar }));
  };

  /**
   * Shows the settings view and highlights the settings menu item.
   * @param {Object} e - The event object from the settings button.
   */
  showSettings = (e) => {
    this.setState({ showSettings: true, viewSelection: "Settings" });
    const getClass = [...document.querySelectorAll('.sidebar-item')];
    getClass.map(x => {
      return x.classList.remove("active");
    });
    e.currentTarget.classList.add("active");

    if (this.state.isMobile ) {
      this.setState({ showSidebar: false });
    }
  };


  /**
   * Handles menu selection changes, updates the view, and highlights the selected menu item.
   * @param {Object} e - The event object from the menu item.
   */
  getSelection = (e) => {
    this.setState({ showSettings: false });
      let thisSelection = "";
      let thisFilter = "";
    if (!e) {
      thisSelection = this.state.viewSelection;
      thisFilter = this.state.viewSelectionFilter;
    } else {
      thisSelection = e.currentTarget.dataset.selection;
      thisFilter = e.currentTarget.dataset.filter;
    }
    this.init(thisFilter);
    if (e) {
      const getClass = [...document.querySelectorAll('.sidebar-item')];
      getClass.map(x => {
        return x.classList.remove("active");
      });
      e.currentTarget.classList.add("active");
    }
    this.setState({ viewSelection: thisSelection, viewSelectionFilter: thisFilter });

    if (this.state.isMobile ) {
      this.setState({ showSidebar: false });
    }
  };

  /**
   * Renders the main dashboard UI, including the sidebar, header, assignments list, settings, and footer.
   * @returns {JSX.Element}
   */
  render() {
    const { brand, studentDetails, hasAssignments, showSidebar, viewSelection, menuItems, showSettings } = this.state;

    return (
      <>
        <MobileHeader 
          sidebartoggle={this.sidebarToggle} 
          showSidebar={showSidebar} 
          student={this.props.student} 
        />
        <Sidebar 
          showLink={this.showLinkAccount} 
          showSettings={this.showSettings} 
          sidebartoggle={this.sidebarToggle} 
          getSelection={this.getSelection} 
          showSidebar={showSidebar} 
          student={this.props.student} 
          menuitems={menuItems} 
        />
        <div className={`Main ${showSidebar === true ? "sidebar-open" : "sidebar-close"}`}>
          <div className="display-area">

            <h1 className="selection-main-header">{viewSelection}</h1>

            {showSettings == false ?
              <>

                {hasAssignments ?
                  <>
                    <div className="list-group">
                      <ul className="row assignment-ul">
                        {studentDetails.map(c =>
                          <AssignmentListItem
                            key={c.assignmentkey}
                            data={c}
                            brand={brand}
                            isMobile={this.state.isMobile}
                          />
                        )}
                      </ul>
                    </div>
                  </>
                  :
                  <p className="noAssignments">There is currently nothing to show for <span className="lower-case bold-text">{viewSelection}</span>.<br />Please speak to your teacher if you think this is incorrect.</p>
                }
              </>
              :
              <Settings student={this.props.student} gethelp={this.props.gethelp} />
            }

            <Footer />
          </div>
        </div>
      </>
    );
  }
}
